import script from "./shipmentList.vue?vue&type=script&setup=true&name=shipmentList&lang=js"
export * from "./shipmentList.vue?vue&type=script&setup=true&name=shipmentList&lang=js"

const __exports__ = script;

export default __exports__